const Lang         = require('lang');
const GlobalAlerts = require('./GlobalAlerts');

function ReimportacaoLotes() {
  nifty.body.overlay({
    fixed: true
  });

  applyListeners();
}

/**aplica listener ao botão para reimportar
 *
 * @return  void
 */
function applyListeners() {
  const buttonsDetails = document.querySelectorAll('[data-lote-importar]');

  if (buttonsDetails.length) {
    buttonsDetails.forEach((currentButton) => {
      currentButton.addEventListener('click', clickButtonImport);
    });
  }
}

/**
 * pega os valores para serem enviados na request
 *
 * @param   event
 * @return
 */
function clickButtonImport(event) {
  const button = event.target;
  const url = button.dataset.loteUrl;
  const loteContentClass = button.dataset.loteContentClass;
  const idLote = button.dataset.loteId

  nifty.body.overlay('show');

  sendRequest(url, idLote)
    .done(function(data) {
      showMessage(data.message, 'success');
      setTimeout(() => {
        location.reload();
      }, 2500);
    })
    .fail(function(error) {
      showMessage(error.responseJSON.message, 'danger');
    })
    .always(function () {
      nifty.body.overlay('hide');
    });
}

/**
 * dispara requisição ajax
 *
 * @param  url
 * @param  idLote
 *
 * @return void
 */
function sendRequest(url, idLote) {
  return $.ajax({
    method: 'POST',
    url: url,
    data: {'idLote': idLote}
  });
}

/**
 * Exibe a mensagem de erro ou sucesso
 *
 * @param  message
 * @param  type
 *
 * @return void
 */
function showMessage(message, type) {
  GlobalAlerts.createAndShow({
    type: type,
    title: '',
    message: message
  });
}

module.exports = {
  init: ReimportacaoLotes,
  url: /^\/admin\/importacao/,
  applyListeners: applyListeners,
};
